const defaultLocale = 'en-US';

export const getFormattedNumber = (value: number, locale: string = defaultLocale): string =>
  new Intl.NumberFormat(locale).format(value);

export const getFormattedDate = (
  value: Date | number | string,
  locale: string = defaultLocale
): string => new Intl.DateTimeFormat(locale).format(new Date(value));
